import { useEffect, useState } from 'react'
import { Sun, Moon, Monitor } from 'lucide-react'
import { cn } from '../../lib/cn'
import { getThemePreference, setThemePreference, type ThemePreference } from '../../lib/theme'

const ORDER: ThemePreference[] = ['light', 'dark', 'system']
const LABEL: Record<ThemePreference, string> = { light: 'Light', dark: 'Dark', system: 'System' }

/** Cycles light → dark → system. Pill icon button, same size as the other header controls. */
export function ThemeToggle({ className }: { className?: string }) {
  const [pref, setPref] = useState<ThemePreference>('system')
  useEffect(() => {
    setPref(getThemePreference())
    const onChange = (e: Event) => setPref((e as CustomEvent<ThemePreference>).detail)
    window.addEventListener('doable-theme', onChange)
    return () => window.removeEventListener('doable-theme', onChange)
  }, [])
  const next = ORDER[(ORDER.indexOf(pref) + 1) % ORDER.length]!
  const Icon = pref === 'dark' ? Moon : pref === 'light' ? Sun : Monitor
  return (
    <button
      type="button"
      onClick={() => setThemePreference(next)}
      aria-label={`Theme: ${LABEL[pref]}. Switch to ${LABEL[next]}`}
      title={`Theme: ${LABEL[pref]}`}
      className={cn('inline-flex size-9 items-center justify-center rounded-full text-muted-foreground transition-colors hover:bg-muted hover:text-foreground [&_svg]:size-4', className)}
    >
      <Icon />
    </button>
  )
}
